import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as Logoen } from "../Images/public/logo_temp_en.svg";
import { ReactComponent as Logofa } from "../Images/public/logo_temp_fa.svg";
import { ReactComponent as Favorite } from "../Images/public/favorite.svg";
import { ReactComponent as Person } from "../Images/public/person-2.svg";
import { ReactComponent as Basket } from "../Images/public/basket-2.svg";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  CartUpdatedFalse,
  HideLogin2Modal,
  HideLoginModal,
  MultipleAdded,
  MultipleAddedOff,
  LOGIN,
  LOGOUT,
  REGISTER,
  ShowLoginModal,
} from "../Actions/types";
import ModalLogin from "./ModalLogin";
import GetUserProjectData from "../Functions/GetUserProjectData";
import AddProjectToCart from "../Functions/AddProjectToCart";
import authHeader from "../Services/auth-header";
import { refreshToken } from "../Services/auth.service";
import PopoverStickOnClick from "./PopoverStickOnClick";
import NumberToPersianWord from "number_to_persian_word";
import { Accordion, AccordionContext, useAccordionButton } from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import {
  imgUrl,
  baseURLGet,
  baseURLMenu,
  baseURLLogin,
  baseURLRegister,
  baseURLCheckEmail,
  baseURLReset,
  baseURLGetCartCount,
  baseURLAddMulti
} from "../config/api";


function Header() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [pageLanguage, setPageLanguage] = useState(
    location.pathname
      .split("")
      .slice(1, 3)
      .join("")
  );
  const { isLoggedIn, showLogin, showLogin2, cartUpdated, multipleAdded, mainCart } = useSelector(
    (state) => state.auth
  );
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const firstRender = useRef(true);
  const [banner, setBanner] = useState([]);
  const [bannerOneSlide, setBannerOneSlide] = useState([]);
  const [bannerItem, setBannerItem] = useState({
    text1: "",
    text2: "",
    url: "/",
    nextI: 0,
  });
  const [bannerItemOneSlide, setBannerItemOneSlide] = useState([]);
  const [langLocation, setLangLocation] = useState({
    locationEN: "/en",
    locationFA: "/fa",
  });
  const [menu, setMenu] = useState([]);
  const [menuRender, setMenuRender] = useState([]);
  const [menuRender2, setMenuRender2] = useState([]);
  const [mobMenuRender, setMobMenuRender] = useState([]);
  const [mobMenuRender2, setMobMenuRender2] = useState([]);
  const [currentPage, setCurrentPage] = useState({
    level1: "",
    level2: "",
    level3: "",
  });

  const [cart, setCart] = useState({});
  const [draperyCount, setDraperyCount] = useState(0);
  const [productCount, setProductCount] = useState(0);
  const [swatchesCount, setSwatchesCount] = useState(0);

  const [cartCount, setCartCount] = useState(0);

  const [forgotEmail, setForgotEmail] = useState("");
  const [resetPage, setResetPage] = useState(false);

  const [loginInfo, setLoginInfo] = useState({
    email: "",
    password: "",
    remember: false,
  });
  const [registerInfo, setRegisterInfo] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    passwordConfirm: "",
    news: true,
  });
  const [showRegister, setShowRegister] = useState(false);
  const [emailNotValid, setEmailNotValid] = useState(false);
  const [passwordMatch, setPasswordMatch] = useState(false);
  const [passwordMatchNotValid, setPasswordMatchNotValid] = useState(false);
  const [passwordNotValidState, setPasswordNotValidState] = useState(0);
  const [mobileErrorState, setMobileErrorState] = useState(0);
  const [emailErrorState, setEmailErrorState] = useState(0);
  const [passwordNotValid, setPasswordNotValid] = useState(false);
  const [showPasswordValidation, setShowPasswordValidation] = useState(false);
  const [passwordValidation, setPasswordValidation] = useState({
    count: false,
    lowercase: false,
    uppercase: false,
    numbers: false,
  });
  const [firstNotExist, setFirstNotExist] = useState(false);
  const [lastNotExist, setLastNotExist] = useState(false);
  const [emailNotExist, setEmailNotExist] = useState(false);
  const [mobileNotExist, setMobileNotExist] = useState(false);

  // Detect main domain (doopsalta2.com) to switch between menus
  const [isDoopsalta2Domain, setIsDoopsalta2Domain] = useState(false);

  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isSubNavOpen, setIsSubNavOpen] = useState({});
  const [showSearch, setShowSearch] = useState(false);
  const [index, setIndex] = useState(0);
  const [slideList, setSlideList] = useState([]);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  const signIn = useRef(null);
  const fixedHeader = useRef(null);
  const mobNav = useRef(null);

  const mobileError = {
    en: [{ error: "Please enter a valid mobile." }, { error: "Please enter a valid mobile." }],
    fa: [
      { error: "لطفا شماره موبایل معتبری وارد کنید." },
      { error: "لطفا شماره موبایل معتبری وارد کنید." },
    ],
  };

  const emailError = {
    en: [
      { error: "Please include an '@' in the email address." },
      { error: "A part following '@' should not contain the symbol '@'." },
      { error: "Please enter a part followed by '@'." },
      { error: "Please enter a part following '@'." },
      { error: "Please include an '.' in the part following '@'." },
      { error: "'.' is used at a wrong position" },
      { error: "Please enter a part followed by '.'." },
      { error: "The email is invalid." },
      { error: "This email address is already associated with an account." },
    ],
    fa: [
      { error: "ایمیل شما بایستی نماد '@' داشته باشد." },
      { error: "بخش پس از '@' نباید دارای نماد '@' باشد." },
      { error: "بخش قبل از '@' را وارد کنید." },
      { error: "بخش پس از '@' را وارد کنید." },
      { error: "لطفا یک '.' را در قسمت بعد '@' وارد کنید." },
      { error: "'.' در مکان نادرستی استفاده شده است." },
      { error: "بخش پس از '.' را وارد کنید." },
      { error: "ایمیل نادرست میباشد." },
      { error: "این آدرس ایمیل با حساب کاربری دیگری مرتبط است." },
    ],
  };
  const [btn_disabled, setBtn_disabled] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [successText, setSuccessText] = useState("");
  const validateEmail = (email) => {
    if (
      email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/
      )
    ) {
      return true;
    } else {
      if (!email.includes("@")) {
        setEmailErrorState(0);
      } else {
        const myArray = email.split("@");
        if (myArray.length - 1 > 1) {
          setEmailErrorState(1);
        } else if (myArray[0] === "") {
          setEmailErrorState(2);
        } else if (myArray[1] === "") {
          setEmailErrorState(3);
        } else if (!myArray[1].includes(".")) {
          setEmailErrorState(4);
        } else {
          const myArray2 = myArray[1].split(".");
          if (myArray2[0] === "") {
            setEmailErrorState(5);
          } else if (myArray2.pop() === "") {
            setEmailErrorState(6);
          } else {
            setEmailErrorState(7);
          }
        }
        return false;
      }
    }
  };

  function validateNumber(user_number) {
    if (user_number.length !== 11) {
      // setMobileNotExist(true);
      setMobileErrorState(0);
      return false;
    } else if (!/^0[0-9].*$/.test(user_number)) {
      // setMobileNotExist(true);
      setMobileErrorState(1);
      return false;
    } else {
      setMobileNotExist(false);
      return true;
    }
  }

  function checkPasswordStrength(user_password) {
    let temp = JSON.parse(JSON.stringify(passwordValidation));
    if (user_password.length > 20) {
      setPasswordNotValidState(0);
    } else if (user_password.length < 8) {
      setPasswordNotValidState(0);
    } else {
      let matchedCase = [];
      matchedCase.push("[A-Z]"); // Uppercase
      matchedCase.push("[a-z]"); // Lowercase
      matchedCase.push("[0-9]"); // Numbers
      let count = 0;
      for (let i = 0; i < matchedCase.length; i++) {
        if (new RegExp(matchedCase[i]).test(user_password)) {
          count++;
        }
      }
      if (count === 3) {
        setPasswordNotValidState(1);
        setPasswordNotValid(false);
      } else {
        setPasswordNotValidState(0);
      }
    }

    temp.count = user_password.length <= 20 && user_password.length >= 8;

    temp.uppercase = new RegExp("[A-Z]").test(user_password);

    temp.lowercase = new RegExp("[a-z]").test(user_password);

    temp.numbers = new RegExp("[0-9]").test(user_password);

    setPasswordValidation(temp);
  }

  function registerUser() {
    if (passwordNotValidState === 0) {
      setPasswordNotValid(true);
    }

    if (!passwordMatch) {
      setPasswordMatchNotValid(true);
    }

    if (registerInfo.firstName.length === 0) {
      setFirstNotExist(true);
    }

    if (registerInfo.lastName.length === 0) {
      setLastNotExist(true);
    }
    if (registerInfo.phone === "") {
      setMobileNotExist(true);
    } else if (!validateNumber(registerInfo.phone)) {
      setMobileNotExist(true);
    } else {
      setMobileNotExist(false);
    }

    if (registerInfo.email.length === 0) {
      setEmailNotExist(true);
    } else if (!validateEmail(registerInfo.email)) {
      setEmailNotValid(true);
    } else {
      let promise1 = new Promise((resolve, reject) => {
        axios
          .get(baseURLCheckEmail, {
            params: {
              username: registerInfo.email,
            },
          })
          .then((response) => {
            if (response.data) {
              resolve();
            } else {
              setEmailErrorState(8);
              setEmailNotValid(true);
              reject();
            }
          })
          .catch((err) => {
            console.log(err);
            setEmailErrorState(7);
            setEmailNotValid(true);
            reject();
          });
      });
      promise1.then(() => {
        if (
          passwordMatch &&
          passwordNotValidState === 1 &&
          registerInfo.email.length !== 0 &&
          registerInfo.lastName.length !== 0 &&
          registerInfo.firstName.length !== 0 &&
          (registerInfo.phone === "" || validateNumber(registerInfo.phone))
        ) {
          setBtn_disabled(true);
          let tempPostObj = {};
          tempPostObj["Email"] = registerInfo.email;
          tempPostObj["Password"] = registerInfo.password;
          tempPostObj["FirstName"] = registerInfo.firstName;
          tempPostObj["LastName"] = registerInfo.lastName;
          tempPostObj["Mobile"] = registerInfo.phone;
          if (tempPostObj["Mobile"] === "") {
            tempPostObj["Mobile"] = null;
          }
          axios
            .post(baseURLRegister, tempPostObj)
            .then((response) => {
              // setShowToast_register_ok(true);
              // setSuccessText(t("verify_email_sent"));
              window.scrollTo(0, 0);
              setTimeout(() => {
                loginUser(registerInfo.email, registerInfo.password, true);
                setBtn_disabled(false);
              }, 1000);
            })
            .catch((err) => {
              console.log(err);
              // setShowToast_register_fail(true);
              setErrorText(t("Registration failed."));
              window.scrollTo(0, 0);
              setTimeout(() => {
                setBtn_disabled(false);
              }, 1000);
            });
        }
      });
    }
  }

  function loginUser(email = loginInfo.email, password = loginInfo.password, isRegister) {
    setBtn_disabled(true);
    // let tempPostObj = {};
    // tempPostObj["username"] = loginInfo.email;
    // tempPostObj["password"] = loginInfo.password;
    // tempPostObj["grant_type"] = "password";
    signIn.current.innerHTML = t("Please wait");

    const formData = new URLSearchParams();
    formData.append("username", email);
    formData.append("password", password);
    formData.append("grant_type", "password");
    axios
      .post(baseURLLogin, formData, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((response) => {
        // if (loginInfo.remember) {
        localStorage.setItem("user", JSON.stringify(response.data));
        // } else {
        //     let tempObj = response.data;
        //     delete tempObj["refresh_token"];
        //     localStorage.setItem('user', JSON.stringify(tempObj));
        // }
        // setShowToast_login_ok(true);
        setTimeout(() => {
          if (isRegister) {
            dispatch({
              type: REGISTER,
              payload: { user: response.data },
            });
          } else {
            dispatch({
              type: LOGIN,
              payload: { user: response.data },
            });
          }
          dispatch({
            type: HideLoginModal,
          });
        }, 3000);
      })
      .catch((err) => {
        console.log(err);
        // setShowToast_login_fail(true);
        setErrorText(t("Invalid email or password."));
        setTimeout(() => {
          signIn.current.innerHTML = t("SIGN IN");
          setBtn_disabled(false);
        }, 1000);
      });
  }

  function sendResetPasswordRequest() {
    axios
      .post(
        baseURLReset,
        {},
        {
          params: {
            userName: forgotEmail,
          },
        }
      )
      .then((response) => {
        setSuccessText(t("update_password_sent"));
      })
      .catch((err) => {
        setErrorText(t("Invalid email for reset"));
      });
  }

  useEffect(() => {
    if (errorText !== "") setSuccessText("");
  }, [errorText]);

  useEffect(() => {
    if (successText !== "") setErrorText("");
  }, [successText]);

  useEffect(() => {
    if (emailNotExist) setEmailNotValid(false);
  }, [emailNotExist]);

  useEffect(() => {
    if (emailNotValid) setEmailNotExist(false);
  }, [emailNotValid]);

  const mega = useRef({});
  const closeMenuTimeout = useRef(null);

  function closeAllDesktopMenus() {
    if (closeMenuTimeout.current) {
      clearTimeout(closeMenuTimeout.current);
      closeMenuTimeout.current = null;
    }
    Object.keys(mega.current).forEach((key) => {
      if (mega.current[key]) {
        mega.current[key].className = "mega";
        mega.current[key].style.display = "";
      }
    });
  }

  function openDesktopMenu(index) {
    if (closeMenuTimeout.current) {
      clearTimeout(closeMenuTimeout.current);
      closeMenuTimeout.current = null;
    }
    Object.keys(mega.current).forEach((key) => {
      if (mega.current[key]) mega.current[key].classList.remove("is-open");
    });
    if (mega.current[index]) mega.current[index].classList.add("is-open");
  }

  function scheduleCloseDesktopMenu(index) {
    if (closeMenuTimeout.current) clearTimeout(closeMenuTimeout.current);
    closeMenuTimeout.current = setTimeout(() => {
      if (mega.current[index]) mega.current[index].classList.remove("is-open");
      closeMenuTimeout.current = null;
    }, 120);
  }

  function cancelCloseDesktopMenu() {
    if (closeMenuTimeout.current) {
      clearTimeout(closeMenuTimeout.current);
      closeMenuTimeout.current = null;
    }
  }

  function convertToPersian(string_farsi) {
    let tempString = string_farsi.replace("ي", "ی");
    tempString = tempString.replace("ي", "ی");
    tempString = tempString.replace("ي", "ی");
    tempString = tempString.replace("ي", "ی");
    tempString = tempString.replace("ك", "ک");
    return tempString;
  }

  function getBanner() {
    axios
      .get(baseURLGet)
      .then((response) => {
        let arr = response.data;
        let temparr = [];
        arr.banner.forEach((obj) => {
          if (
            obj["lang"] ===
            location.pathname
              .split("")
              .slice(1, 3)
              .join("")
          ) {
            temparr = [...temparr, obj];
          }
        });
        if (temparr[0].oneSlide === "true") {
          setBannerOneSlide(temparr);
        } else setBanner(temparr);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function renderBanner(bannerIndex) {
    if (bannerIndex === banner.length) bannerIndex = 0;
    let text1 = banner[bannerIndex].text1;
    let text2 = banner[bannerIndex].text2;
    let url = banner[bannerIndex].url;
    setBannerItem({
      text1: text1,
      text2: text2,
      url: url,
      nextI: bannerIndex + 1,
    });
  }

  function renderBannerOneSlide() {
    const bannerList = [];
    const slideLists = [];
    let promiseArr = [];
    for (let i = 0; i < bannerOneSlide.length; i++) {
      promiseArr[i] = new Promise((resolve, reject) => {
        let text1 = bannerOneSlide[i].text1;
        let text2 = bannerOneSlide[i].text2;
        let url = bannerOneSlide[i].url;
        let fontSize = bannerOneSlide[i].fontSize;

        bannerList.push(
          <Link
            className="banner_oneSlide_item_container"
            key={"banner" + i}
            to={"/" + url}
            style={{ fontSize: fontSize + "px" }}
          >
            <div
              className={`banner_oneSlide_item ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
            >
              <span>{text1}</span>&nbsp;
              <span className="text_underline">{text2}</span>
            </div>
          </Link>
        );
        if (i !== bannerOneSlide.length - 1) {
          bannerList.push(
            <span key={"banner_seperator" + i} className="banner_seperator">
              &nbsp;|&nbsp;
            </span>
          );
        }
        slideLists.push(
          <Carousel.Item
            interval={4000}
            key={"slide" + i}
            slide_id={i}
            className={`unselectable ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
          >
            <Link
              className="banner_oneSlide_item_container"
              key={"banner" + i}
              to={"/" + url}
              style={{ fontSize: fontSize + "px" }}
            >
              <div
                className={`banner_oneSlide_item ${
                  pageLanguage === "fa" ? "font_farsi" : "font_en"
                }`}
              >
                <span>{text1}</span>&nbsp;
                <span className="text_underline">{text2}</span>
              </div>
            </Link>
          </Carousel.Item>
        );
        resolve();
      });
    }
    Promise.all(promiseArr).then(() => {
      setSlideList(slideLists);
      setBannerItemOneSlide(bannerList);
    });
  }

  async function getMenu() {
    axios
      .get(baseURLMenu)
      .then((response) => {
        let arr = response.data;
        setMenu(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function ContextAwareToggleMenu({ eventKey, callback, textOnHide, textOnShow }) {
    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
      <div className="nav_menu" aria-expanded={`${isCurrentEventKey}`} onClick={decoratedOnClick}>
        <h4 className="nav_menu_title">{isCurrentEventKey ? textOnShow : textOnHide}</h4>
        <div className="menu_icon">
          <img
            src={
              isCurrentEventKey
                ? require("../Images/public/minus.svg").default
                : require("../Images/public/plus.svg").default
            }
            className="img-fluid"
            alt=""
          />
        </div>
      </div>
    );
  }

  function renderMenu() {
    let pageLanguage = location.pathname
      .split("")
      .slice(1, 3)
      .join("");

    let sortedMenu = [];
    let promiseArr = [];
    for (let i = 0; i < menu.length; i++) {
      promiseArr[i] = new Promise((resolve, reject) => {
        sortedMenu[menu[i].MenuOrder] = menu[i];
        resolve();
      });
    }

    Promise.all(promiseArr).then(() => {
      let promiseArr = [];
      for (let i = 0; i < sortedMenu.length; i++) {
        promiseArr[i] = new Promise((resolve, reject) => {
          let Children = sortedMenu[i].Children;
          let tempArr = [];
          let promiseArr2 = [];
          for (let j = 0; j < Children.length; j++) {
            promiseArr2[j] = new Promise((resolve, reject) => {
              tempArr[Children[j].MenuOrder] = Children[j];
              resolve();
            });
          }
          Promise.all(promiseArr2).then(() => {
            sortedMenu[i].Children = tempArr;
            resolve();
          });
        });
      }

      Promise.all(promiseArr).then(() => {
        let promiseArr = [];
        for (let i = 0; i < sortedMenu.length; i++) {
          promiseArr[i] = new Promise((resolve, reject) => {
            let Children = sortedMenu[i].Children;
            let promiseArr2 = [];
            for (let j = 0; j < Children.length; j++) {
              promiseArr2[j] = new Promise((resolve, reject) => {
                let subChildren = Children[j].Children;
                let tempArr = [];
                let promiseArr3 = [];
                for (let k = 0; k < subChildren.length; k++) {
                  promiseArr3[k] = new Promise((resolve, reject) => {
                    tempArr[subChildren[k].MenuOrder] = subChildren[k];
                    resolve();
                  });
                }
                Promise.all(promiseArr3).then(() => {
                  sortedMenu[i].Children[j].Children = tempArr;
                  resolve();
                });
              });
            }
            Promise.all(promiseArr2).then(() => {
              resolve();
            });
          });
        }
        Promise.all(promiseArr).then(() => {
          const menuList = [];
          const menuList2 = [];
          const menuListStore = [];
          const menuList2Store = [];
          let promiseArr = [];
          for (let i = 0; i < sortedMenu.length; i++) {
            promiseArr[i] = new Promise((resolve, reject) => {
              let MenuName = convertToPersian(sortedMenu[i].MenuName);
              let MenuEnName = sortedMenu[i].MenuEnName;
              let WebsitePageId = sortedMenu[i].WebsitePageId;
              let Children = sortedMenu[i].Children;

              const buffer = [];
              const bufferStore = [];
              const subMenuList = [];
              const subMenuListStore = [];
              const subMenuList2 = [];
              const subMenuList2Store = [];
              let promiseArr2 = [];
              for (let j = 0; j < Children.length; j++) {
                promiseArr2[j] = new Promise((resolve, reject) => {
                  let subMenuName = convertToPersian(Children[j].MenuName);
                  let subMenuEnName = Children[j].MenuEnName;
                  let subChildren = Children[j].Children;
                  let subWidth = Children[j].Width;
                  let subImageUrl = Children[j].ImageUrl;
                  let subPageTypeId = Children[j].PageTypeId;
                  let subCategoryId = Children[j].PageName;
                  let subPageType =
                    subPageTypeId === 5501 ? Children[j].RelatedPage || "Product" : "Curtain";
                  let subIsActive = Children[j].IsActive;

                  if (subImageUrl !== null) {
                    const imageLinkTo = "/" + pageLanguage + "/" + subPageType + "/" + subCategoryId;
                    const imageContent = (
                      <>
                        <img
                          className="img-fluid"
                          src={imgUrl(subImageUrl)}
                          alt=""
                        />
                        <h5 className="nav_menu_img_title">
                          {pageLanguage === "en" ? subMenuEnName : subMenuName}
                        </h5>
                      </>
                    );
                    buffer.push(
                      <Link
                        to={imageLinkTo}
                        className="nav_menu_img"
                        onClick={() => {
                          setIsNavOpen(false);
                          setIsSubNavOpen({});
                          menuClicked(i);
                        }}
                      >
                        {imageContent}
                      </Link>
                    );
                    bufferStore.push(
                      subIsActive ? (
                        <Link
                          to={imageLinkTo}
                          className="nav_menu_img"
                          onClick={() => {
                            setIsNavOpen(false);
                            setIsSubNavOpen({});
                            menuClicked(i);
                          }}
                        >
                          {imageContent}
                        </Link>
                      ) : (
                        <span className="nav_menu_img">{imageContent}</span>
                      )
                    );
                    let empty_fields = 12;

                    let promiseArr4 = [];
                    for (let emptyCounter = 0; emptyCounter < empty_fields; emptyCounter++) {
                      promiseArr4[emptyCounter] = new Promise((resolve, reject) => {
                        const emptyItem = (
                          <h2
                            key={"subSubMenu" + i + j + "empty" + emptyCounter}
                            className="emptySubMenu"
                          >
                            &nbsp;
                          </h2>
                        );
                        buffer.push(emptyItem);
                        bufferStore.push(emptyItem);

                        resolve();
                      });
                    }

                    Promise.all(promiseArr4).then(() => {
                      resolve();
                    });
                  } else {
                    if (subChildren.length === 0) {
                      const subMenuTitle = (
                        <h1
                          key={"subMenu" + i + j + "noChild" + "title"}
                          className="subMenu_title"
                          style={{ maxWidth: subWidth + "px" }}
                        >
                          {pageLanguage === "en" ? subMenuEnName : subMenuName}
                        </h1>
                      );
                      buffer.push(subMenuTitle);
                      bufferStore.push(subMenuTitle);
                      const subNavItem = (
                        <li key={"subMenu2" + i + j + "noChild" + "title"} className="SubNav_item">
                          <div className="nav_menu">
                            <h4 className="nav_menu_title">
                              {pageLanguage === "en" ? subMenuEnName : subMenuName}
                            </h4>
                          </div>
                        </li>
                      );
                      subMenuList2.push(subNavItem);
                      subMenuList2Store.push(subNavItem);

                      resolve();
                    } else {
                      const subMenuTitle = (
                        <h1
                          key={"subMenu" + i + j + "title"}
                          className="subMenu_title"
                          style={{ maxWidth: subWidth + "px" }}
                        >
                          {pageLanguage === "en" ? subMenuEnName : subMenuName}
                        </h1>
                      );
                      buffer.push(subMenuTitle);
                      bufferStore.push(subMenuTitle);

                      let empty_fields = 0;
                      const subsubMenuList2 = [];
                      const subsubMenuList2Store = [];
                      let promiseArr3 = [];
                      for (let k = 0; k < subChildren.length; k++) {
                        promiseArr3[k] = new Promise((resolve, reject) => {
                          let subSubMenuName = convertToPersian(subChildren[k].MenuName);
                          let subSubMenuEnName = subChildren[k].MenuEnName;
                          let subSubIsActive = subChildren[k].IsActive;
                          let subSubWebsitePageId = subChildren[k].WebsitePageId;
                          let subSubChildren = subChildren[k].Children;
                          let subSubWidth = subChildren[k].Width;
                          let subSubPageTypeId = subChildren[k].PageTypeId;
                          let subSubCategoryId = subChildren[k].PageName
                            ? subChildren[k].PageName.toLowerCase()
                            : "";
                          let subSubPageType =
                            subSubPageTypeId === 5501
                              ? subChildren[k].RelatedPage
                                ? subChildren[k].RelatedPage.toLowerCase()
                                : "product"
                              : "curtain";
                          if (subSubMenuEnName === "") {
                            empty_fields++;
                          } else {
                            const subSubLinkTo =
                              "/" + pageLanguage + "/" + subSubPageType + "/" + subSubCategoryId;
                            const subSubLabel =
                              pageLanguage === "en" ? subSubMenuEnName : subSubMenuName;

                            buffer.push(
                              <h2 key={"subSubMenu" + i + j + k}>
                                <Link
                                  className="subSubMenu"
                                  to={subSubLinkTo}
                                  onClick={() => {
                                    menuClicked(i);
                                  }}
                                >
                                  {subSubLabel}
                                </Link>
                              </h2>
                            );

                            bufferStore.push(
                              <h2 key={"subSubMenuStore" + i + j + k}>
                                {subSubIsActive ? (
                                  <Link
                                    className="subSubMenu"
                                    to={subSubLinkTo}
                                    onClick={() => {
                                      menuClicked(i);
                                    }}
                                  >
                                    {subSubLabel}
                                  </Link>
                                ) : (
                                  <span className="subSubMenu">{subSubLabel}</span>
                                )}
                              </h2>
                            );

                            subsubMenuList2.push(
                              <li
                                key={"subsubMenu2" + i + j + k + "title"}
                                className="SubSubNav_item"
                              >
                                <Link
                                  to={subSubLinkTo}
                                  className="nav_menu"
                                  onClick={() => {
                                    setIsNavOpen(false);
                                    setIsSubNavOpen({});
                                  }}
                                >
                                  <h4 className="nav_menu_title">{subSubLabel}</h4>
                                </Link>
                              </li>
                            );

                            subsubMenuList2Store.push(
                              <li
                                key={"subsubMenu2Store" + i + j + k + "title"}
                                className="SubSubNav_item"
                              >
                                {subSubIsActive ? (
                                  <Link
                                    to={subSubLinkTo}
                                    className="nav_menu"
                                    onClick={() => {
                                      setIsNavOpen(false);
                                      setIsSubNavOpen({});
                                    }}
                                  >
                                    <h4 className="nav_menu_title">{subSubLabel}</h4>
                                  </Link>
                                ) : (
                                  <div className="nav_menu">
                                    <h4 className="nav_menu_title">{subSubLabel}</h4>
                                  </div>
                                )}
                              </li>
                            );
                          }
                          resolve();
                        });
                      }
                      let promiseArr4 = [];
                      for (let emptyCounter = 0; emptyCounter < empty_fields; emptyCounter++) {
                        promiseArr4[emptyCounter] = new Promise((resolve, reject) => {
                          const emptyItem = (
                            <h2
                              key={"subSubMenu" + i + j + "empty" + emptyCounter}
                              className="emptySubMenu"
                            >
                              &nbsp;
                            </h2>
                          );
                          buffer.push(emptyItem);
                          bufferStore.push(emptyItem);

                          resolve();
                        });
                      }

                      Promise.all([...promiseArr3, ...promiseArr4]).then(() => {
                        const accordionItem = (
                          <li key={"subMenu2" + i + j + "title"} className="SubNav_item">
                            <Accordion>
                              <Accordion.Item eventKey="0">
                                <ContextAwareToggleMenu
                                  eventKey="0"
                                  textOnHide={pageLanguage === "en" ? subMenuEnName : subMenuName}
                                  textOnShow={pageLanguage === "en" ? subMenuEnName : subMenuName}
                                />
                                <Accordion.Body className="nav_accordion_dropdown">
                                  <ul className="nav_body_items subNav_body_items">
                                    {subsubMenuList2}
                                  </ul>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Accordion>
                          </li>
                        );
                        const accordionItemStore = (
                          <li key={"subMenu2Store" + i + j + "title"} className="SubNav_item">
                            <Accordion>
                              <Accordion.Item eventKey="0">
                                <ContextAwareToggleMenu
                                  eventKey="0"
                                  textOnHide={pageLanguage === "en" ? subMenuEnName : subMenuName}
                                  textOnShow={pageLanguage === "en" ? subMenuEnName : subMenuName}
                                />
                                <Accordion.Body className="nav_accordion_dropdown">
                                  <ul className="nav_body_items subNav_body_items">
                                    {subsubMenuList2Store}
                                  </ul>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Accordion>
                          </li>
                        );
                        subMenuList2.push(accordionItem);
                        subMenuList2Store.push(accordionItemStore);
                        resolve();
                      });
                    }
                  }
                });
              }

              Promise.all(promiseArr2).then(() => {
                let promiseArr5 = [];
                for (let m = 0; m < buffer.length; m += 13) {
                  promiseArr5[m] = new Promise((resolve, reject) => {
                    let subSubMenuList = [];
                    let subSubMenuListStore = [];
                    for (let n = m; n < m + 13; n++) {
                      if (n === buffer.length) break;
                      else {
                        const el = buffer[n];
                        subSubMenuList.push(
                          React && React.isValidElement && React.isValidElement(el) ? (
                            React.cloneElement(el, {
                              key: "subSub" + i + "-" + WebsitePageId + "-" + m + "-" + n,
                            })
                          ) : (
                            <React.Fragment
                              key={"subSub" + i + "-" + WebsitePageId + "-" + m + "-" + n}
                            >
                              {el}
                            </React.Fragment>
                          )
                        );

                        const elStore = bufferStore[n];
                        subSubMenuListStore.push(
                          React && React.isValidElement && React.isValidElement(elStore) ? (
                            React.cloneElement(elStore, {
                              key: "subSubStore" + i + "-" + WebsitePageId + "-" + m + "-" + n,
                            })
                          ) : (
                            <React.Fragment
                              key={"subSubStore" + i + "-" + WebsitePageId + "-" + m + "-" + n}
                            >
                              {elStore}
                            </React.Fragment>
                          )
                        );
                      }
                    }
                    subMenuList.push(
                      <div className="cel-top-menu" key={"subMenu3" + i + WebsitePageId + m}>
                        {subSubMenuList}
                      </div>
                    );
                    subMenuListStore.push(
                      <div
                        className="cel-top-menu"
                        key={"subMenu3Store" + i + WebsitePageId + m}
                      >
                        {subSubMenuListStore}
                      </div>
                    );
                    resolve();
                  });
                }

                Promise.all(promiseArr5).then(() => {
                  menuList[i] = (
                    <li key={"menu" + i}>
                      <h1
                        onMouseEnter={() => openDesktopMenu(i)}
                        onMouseLeave={() => scheduleCloseDesktopMenu(i)}
                      >
                        {pageLanguage === "en" ? MenuEnName : MenuName}
                      </h1>
                      <div
                        ref={(ref) => (mega.current[i] = ref)}
                        className="mega"
                        onMouseEnter={cancelCloseDesktopMenu}
                        onMouseLeave={() => scheduleCloseDesktopMenu(i)}
                      >
                        <div className="sub_menu">{subMenuList}</div>
                      </div>
                    </li>
                  );
                  menuListStore[i] = (
                    <li key={"menuStore" + i}>
                      <h1
                        onMouseEnter={() => openDesktopMenu(i)}
                        onMouseLeave={() => scheduleCloseDesktopMenu(i)}
                      >
                        {pageLanguage === "en" ? MenuEnName : MenuName}
                      </h1>
                      <div
                        ref={(ref) => (mega.current[i] = ref)}
                        className="mega"
                        onMouseEnter={cancelCloseDesktopMenu}
                        onMouseLeave={() => scheduleCloseDesktopMenu(i)}
                      >
                        <div className="sub_menu">{subMenuListStore}</div>
                      </div>
                    </li>
                  );
                  menuList2[i] = (
                    <li key={"menu2" + i} className="Nav_item">
                      <div
                        className="nav_menu"
                        onClick={() => {
                          setIsSubNavOpen((prev) => {
                            return { ...prev, [i]: true };
                          });
                        }}
                      >
                        <h4 className="nav_menu_title">
                          {pageLanguage === "en" ? MenuEnName : MenuName}
                        </h4>
                        <div className="menu_icon">
                          <img
                            src={require("../Images/public/arrow_Right.svg").default}
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                      </div>
                      <div
                        className={
                          isSubNavOpen[i]
                            ? "mobile_nav_container nav_submenu_container nav_open"
                            : "mobile_nav_container nav_submenu_container"
                        }
                      >
                        <div className="nav_header">
                          <div className="nav_header_top">
                            <div className="logo_section">
                              <div className="mobile_logo" onClick={() => setIsNavOpen(false)}>
                                {pageLanguage === "en" ? <Logoen /> : <Logofa />}
                              </div>
                            </div>
                          </div>
                          <div className="nav_header_bottom">
                            <div
                              className="menu_icon"
                              onClick={() =>
                                setIsSubNavOpen((prev) => {
                                  return { ...prev, [i]: false };
                                })
                              }
                            >
                              <img
                                src={require("../Images/public/arrow-back.svg").default}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="close_menu_icon" onClick={() => setIsNavOpen(false)}>
                              <img
                                src={require("../Images/public/close-button.png")}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                        <div className="nav_body">
                          <ul className="nav_body_items">{subMenuList2}</ul>
                        </div>
                      </div>
                    </li>
                  );
                  menuList2Store[i] = (
                    <li key={"menu2Store" + i} className="Nav_item">
                      <div
                        className="nav_menu"
                        onClick={() => {
                          setIsSubNavOpen((prev) => {
                            return { ...prev, [i]: true };
                          });
                        }}
                      >
                        <h4 className="nav_menu_title">
                          {pageLanguage === "en" ? MenuEnName : MenuName}
                        </h4>
                        <div className="menu_icon">
                          <img
                            src={require("../Images/public/arrow_Right.svg").default}
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                      </div>
                      <div
                        className={
                          isSubNavOpen[i]
                            ? "mobile_nav_container nav_submenu_container nav_open"
                            : "mobile_nav_container nav_submenu_container"
                        }
                      >
                        <div className="nav_header">
                          <div className="nav_header_top">
                            <div className="logo_section">
                              <div className="mobile_logo" onClick={() => setIsNavOpen(false)}>
                                {pageLanguage === "en" ? <Logoen /> : <Logofa />}
                              </div>
                            </div>
                          </div>
                          <div className="nav_header_bottom">
                            <div
                              className="menu_icon"
                              onClick={() =>
                                setIsSubNavOpen((prev) => {
                                  return { ...prev, [i]: false };
                                })
                              }
                            >
                              <img
                                src={require("../Images/public/arrow-back.svg").default}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="close_menu_icon" onClick={() => setIsNavOpen(false)}>
                              <img
                                src={require("../Images/public/close-button.png")}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                        <div className="nav_body">
                          <ul className="nav_body_items">{subMenuList2Store}</ul>
                        </div>
                      </div>
                    </li>
                  );
                  resolve();
                });
              });
            });
          }
          Promise.all(promiseArr).then(() => {
            setMenuRender(menuList);
            setMobMenuRender(menuList2);
            setMenuRender2(menuListStore);
            setMobMenuRender2(menuList2Store);
          });
        });
      });
    });
  }

  function menuClicked(index) {
    // Hide immediately on submenu click so mega never briefly
    // reflows in-document during route transition (old mega1 class
    // dropped position:absolute while display:block stayed).
    closeAllDesktopMenus();
  }

  async function setLang() {
    const tempLocationEn = location.pathname.split("");
    tempLocationEn[1] = "e";
    tempLocationEn[2] = "n";
    tempLocationEn.join("");

    const tempLocationFa = location.pathname.split("");
    tempLocationFa[1] = "f";
    tempLocationFa[2] = "a";

    setLangLocation({
      locationEN: tempLocationEn.join(""),
      locationFA: tempLocationFa.join(""),
    });

    if (
      pageLanguage !==
      location.pathname
        .split("")
        .slice(1, 3)
        .join("")
    ) {
      const tempLang = location.pathname.split("");
      const newLang = tempLang.slice(1, 3).join("");
      setPageLanguage(newLang);

      // Add language class to body element
      document.body.classList.remove("language-en", "language-fa");
      document.body.classList.add(`language-${newLang}`);
    }
  }

  function getCartCount() {
    axios
      .get(baseURLGetCartCount, {
        headers: authHeader(),
      })
      .then((response) => {
        setCartCount(response.data);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              getCartCount();
            } else {
              setCartCount(0);
            }
          });
        } else {
          setCartCount(0);
        }
      });
  }

  useEffect(() => {
    setLang().then(() => {
      if (pageLanguage !== "") {
        // setBannerItem({
        //     text1: "", text2: "", url: "/", nextI: 0
        // });
        // setBannerItemOneSlide([]);
        // setMenuRender([]);
        // setTimeout(() => {  console.log("World!"); }, 2000);
        // i18n.changeLanguage(pageLanguage);
        // getMenu().then(() => {
        //     getBanner();
        // });
      }
    });
    let currentPageInfo = JSON.parse(JSON.stringify(currentPage));
    currentPageInfo.level1 = location.pathname.split("/")[2];
    currentPageInfo.level2 = location.pathname.split("/")[3];
    currentPageInfo.level3 = location.pathname.split("/")[4];

    setCurrentPage(currentPageInfo);

    closeAllDesktopMenus();

    if (isLoggedIn) {
      getCartCount();
    } else {
      if (localStorage.getItem("cart") !== null) {
        setCart(JSON.parse(localStorage.getItem("cart")));
      } else {
        setCart({});
      }
      setCartCount(0);
    }
    setShowSearch(false);
    setIsNavOpen(false);
    setIsSubNavOpen({});
    if (mobNav.current) {
      mobNav.current.scrollTop = 0;
    }
  }, [location.pathname]);

  useEffect(() => {
    setBannerItem({
      text1: "",
      text2: "",
      url: "/",
      nextI: 0,
    });
    setBannerItemOneSlide([]);
    setMenuRender([]);
    setMenuRender2([]);
    if (pageLanguage !== "") {
      i18n.changeLanguage(pageLanguage);
      getMenu().then(() => {
        getBanner();
      });
      document.querySelector("html").lang = pageLanguage;
      document.body.dir = pageLanguage === "fa" ? "rtl" : "ltr";
      document.body.className = pageLanguage === "fa" ? "font_farsi" : "font_en";
    }
  }, [pageLanguage]);

  useEffect(() => {
    if (banner.length && pageLanguage !== "") {
      renderBanner(0);
    }
  }, [banner]);

  useEffect(() => {
    if (menu.length) {
      renderMenu();
    }
  }, [menu, isSubNavOpen]);

  //

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (bannerItem.text1.length) {
        renderBanner(bannerItem.nextI);
      }
    }, 4500);

    return () => clearTimeout(timeout);
  }, [bannerItem]);

  useEffect(() => {
    if (bannerOneSlide.length !== 0 && pageLanguage !== "") {
      renderBannerOneSlide();
    }
  }, [bannerOneSlide]);

  useEffect(() => {
    if (cartUpdated) {
      setCart(mainCart || {});
      setTimeout(() => {
        dispatch({
          type: CartUpdatedFalse,
        });
      }, 500);
      // console.log(mainCart);
    }
  }, [cartUpdated]);

  useEffect(() => {
    if (multipleAdded) {
      setTimeout(() => {
        dispatch({
          type: MultipleAddedOff,
        });
      }, 500);
    }
  }, [multipleAdded]);

  useEffect(() => {
    if (Object.keys(cart).length !== 0) {
      if (isLoggedIn) {
        if (cart["CartDetails"]) {
          let draperies = cart["CartDetails"].filter((object1) => {
            return object1["TypeId"] === 6403;
          });

          let products = cart["CartDetails"].filter((object1) => {
            return object1["TypeId"] === 6401;
          });

          let swatches = cart["CartDetails"].filter((object1) => {
            return object1["TypeId"] === 6402;
          });
          setDraperyCount(draperies.length);
          setProductCount(products.length);
          setSwatchesCount(swatches.length);
          setCartCount(draperies.length + products.length + swatches.length);
        } else {
          setDraperyCount(0);
          setProductCount(0);
          setSwatchesCount(0);
          setCartCount(0);
        }
      } else {
        if (cart["drapery"] === undefined || cart["drapery"].length === 0) {
          setDraperyCount(0);
        } else {
          setDraperyCount(cart["drapery"].length);
        }
        if (cart["product"] === undefined || cart["product"] === []) {
          setProductCount(0);
        } else {
          setProductCount(cart["product"].length);
        }
        if (cart["swatches"] === undefined || cart["swatches"] === []) {
          setSwatchesCount(0);
        } else {
          setSwatchesCount(cart["swatches"].length);
        }
        setCartCount(0);
      }
    } else {
      setDraperyCount(0);
      setProductCount(0);
      setSwatchesCount(0);
      setCartCount(0);
    }
  }, [JSON.stringify(cart)]);

  useEffect(() => {
    if (
      isLoggedIn &&
      showLogin2 &&
      localStorage.getItem("cart") !== null &&
      JSON.parse(localStorage.getItem("cart"))["drapery"] !== undefined &&
      JSON.parse(localStorage.getItem("cart"))["drapery"].length > 0
    ) {
      dispatch({
        type: HideLogin2Modal,
      });
      let tempDrapery = JSON.parse(localStorage.getItem("cart"))["drapery"] || [];
      if (tempDrapery.length) {
        let tempArr = [];
        let promiseArr = [];
        tempDrapery.forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            tempArr.push({
              TypeId: 6403,
              Count: 1,
              SewingOrder: obj,
            });
            resolve();
          });
        });

        let promiseArr2 = [];
        tempDrapery.forEach((obj, index) => {
          promiseArr2[index] = new Promise((resolve, reject) => {
            if (obj["ProductId"]) {
              tempArr.push({
                TypeId: 6401,
                Count: obj["Count"],
                ProductId: obj["ProductId"],
              });
            }
            resolve();
          });
        });

        Promise.all([...promiseArr, ...promiseArr2]).then(() => {
          axios
            .post(baseURLAddMulti, tempArr, {
              headers: authHeader(),
            })
            .then((response) => {
              let tempCart = response.data ? response.data : {};
              setCart(response.data ? response.data : {});
              localStorage.removeItem("cart");
              dispatch({
                type: MultipleAdded,
              });
            })
            .catch((err) => {
              console.log(err);
              if (err.response && err.response.status === 401) {
                refreshToken().then((response2) => {
                  if (response2 !== false) {
                  } else {
                  }
                });
              } else {
                localStorage.removeItem("cart");
                console.log("project not added to cart");
              }
            });
        });
      }
    } else if (isLoggedIn && showLogin2) {
      dispatch({
        type: HideLogin2Modal,
      });
    }
    if (
      isLoggedIn &&
      localStorage.getItem("cart") !== null &&
      ((JSON.parse(localStorage.getItem("cart"))["drapery"] !== undefined &&
        JSON.parse(localStorage.getItem("cart"))["drapery"].length > 0) ||
        (JSON.parse(localStorage.getItem("cart"))["product"] !== undefined &&
          JSON.parse(localStorage.getItem("cart"))["product"].length > 0))
    ) {
      let tempDrapery = JSON.parse(localStorage.getItem("cart"))["drapery"] || [];
      if (tempDrapery.length) {
        let tempArr = [];
        let promiseArr = [];
        tempDrapery.forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            GetUserProjectData(obj)
              .then((temp) => {
                let projectObj = obj["PreorderText"];
                if (obj["BorderOrTrimColorEn"] && obj["BorderOrTrimDesignEn"]) {
                  temp["borderPosition"] = obj["borderPosition"];
                  temp["BorderOrTrimColorEn"] = obj["BorderOrTrimColorEn"];
                  temp["BorderOrTrimColorFa"] = obj["BorderOrTrimColorFa"];
                  temp["BorderOrTrimDesignEn"] = obj["BorderOrTrimDesignEn"];
                  temp["BorderOrTrimDesignFa"] = obj["BorderOrTrimDesignFa"];
                }

                AddProjectToCart(
                  temp,
                  projectObj["SewingModelId"],
                  projectObj["Price"],
                  temp["ModelNameEn"],
                  temp["ModelNameFa"],
                  [
                    temp["uploadedImagesFile"] ? temp["uploadedImagesFile"] : [],
                    temp["uploadedImagesURL"] ? temp["uploadedImagesURL"] : [],
                    temp["uploadedPDFFile"] ? temp["uploadedPDFFile"] : [],
                    temp["uploadedPDFURL"] ? temp["uploadedPDFURL"] : [],
                  ],
                  projectObj["SewingOrderId"],
                  undefined,
                  navigate,
                  true,
                  temp["Accessories"][0],
                  true
                )
                  .then((temp2) => {
                    console.log(`temp2`, temp2);
                    tempArr.push({
                      TypeId: 6403,
                      Count: 1,
                      SewingOrder: temp2,
                    });
                    resolve();
                  })
                  .catch((err) => {
                    console.log(err);
                    resolve();
                  });
              })
              .catch((err) => {
                console.log(err);
                resolve();
              });
          });
        });

        let promiseArr2 = [];
        tempDrapery.forEach((obj, index) => {
          promiseArr2[index] = new Promise((resolve, reject) => {
            if (obj["ProductId"]) {
              tempArr.push({
                TypeId: 6401,
                Count: obj["Count"],
                ProductId: obj["ProductId"],
              });
            }
            resolve();
          });
        });

        Promise.all([...promiseArr, ...promiseArr2]).then(() => {
          axios
            .post(baseURLAddMulti, tempArr, {
              headers: authHeader(),
            })
            .then((response) => {
              let tempCart = response.data ? response.data : {};
              setCart(response.data ? response.data : {});
              localStorage.removeItem("cart");
              dispatch({
                type: MultipleAdded,
              });
            })
            .catch((err) => {
              console.log(err);
              if (err.response && err.response.status === 401) {
                refreshToken().then((response2) => {
                  if (response2 !== false) {
                  } else {
                  }
                });
              } else {
                localStorage.removeItem("cart");
                console.log("project not added to cart");
              }
            });
        });
      }
    }
    if (firstRender.current) {
      firstRender.current = false;
    }
  }, [isLoggedIn]);

  const [offset, setOffset] = useState(false);

  const hideHeaderSectionsRoutes = [
    "ready-made-drapery",
    "ready-made-shade",
    "ready-made-fabric",
    "ready-made-product",
    "collection",
    "collections",
    "collection-shade",
  ];
  const pathnameSegment = (location.pathname.split("/")[2] || "").toLowerCase();
  const isHideHeaderSectionsRoute = hideHeaderSectionsRoutes.includes(pathnameSegment);
  const shouldHideHeaderSections = offset && isHideHeaderSectionsRoute;

  useEffect(() => {
    const onScroll = () => {
      // setOffset3(window.pageYOffset);
      // setOffset2(fixedHeader.current.offsetTop);
      if (fixedHeader.current.offsetTop + 180 < window.pageYOffset) {
        setOffset(true);
      } else {
        // if(offset && fixedHeader.current.offsetTop + 64 < window.pageYOffset){
        setOffset(false);
        // }
      }
    };

    // clean up code
    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Apply language class on component mount & detect domain
  useEffect(() => {
    if (typeof window !== "undefined") {
      const hostWithPort = window.location.host.toLowerCase();
      const isMainDomain = hostWithPort.includes("store") || hostWithPort === "localhost:3001";
      setIsDoopsalta2Domain(isMainDomain);
    }

    const currentLang = location.pathname
      .split("")
      .slice(1, 3)
      .join("");
    document.body.classList.remove("language-en", "language-fa");
    document.body.classList.add(`language-${currentLang}`);
  }, []);
  return (
    <div
      className={`header_container padding-clear ${
        pageLanguage === "fa" ? "font_farsi" : "font_en"
      } ${currentPage.level1 === "Checkout" ? "noDisplay" : ""}`}
      ref={fixedHeader}
    >
      <div>
        <div className={offset ? "fixed_header_top top_header" : "top_header"}>
          <div className="col-lg-12 desktop_only">
            <div className={shouldHideHeaderSections ? "display_none" : "top_title"}>
              {bannerItemOneSlide.length === 0 && (
                <Link to={"/" + bannerItem.url}>
                  <span>{bannerItem.text1}</span>&nbsp;
                  <span className="text_underline">{bannerItem.text2}</span>
                </Link>
              )}
              {bannerItemOneSlide.length !== 0 && bannerItemOneSlide}
            </div>
          </div>
          <div className="mobile_only mobile_header_slide">
            <Carousel
              activeIndex={index}
              onSelect={handleSelect}
              variant="dark"
              pause="false"
              controls={false}
            >
              {slideList}
            </Carousel>
          </div>
        </div>
        <div className={offset ? "header_fixed_section fixed_header" : "header_fixed_section"}>
         
          <div className={shouldHideHeaderSections ? "display_none" : "desktop_only"}>
            <div className="mid_header">
              <div className="col-lg-12">
                <div className="mid_header_left">
                  <div className="search-box">
                    <button className="btn-search">
                      <img
                        src={require("../Images/public/main_search_icon.svg").default}
                        className="img-fluid"
                        alt=""
                      />
                      <input
                        type="text"
                        name="input-search_mid"
                        className={`input-search ${
                          pageLanguage === "fa" ? "font_farsi" : "font_en"
                        }`}
                        placeholder={t("Search_placeholder")}
                        autoComplete="new-search"
                      />
                    </button>
                  </div>
                </div>
                <div className="Logo">
                  <Link to={"/" + pageLanguage}>
                    {pageLanguage === "en" ? <Logoen /> : <Logofa />}
                  </Link>
                </div>
                <div className="mid_header_right">
                  <ul className={pageLanguage === "fa" ? "float_left icons" : "float_right icons"}>
                    {currentPage.level1 === "Curtain" &&
                      currentPage.level3 !== undefined &&
                      !isLoggedIn && (
                        <li
                          className="login-open"
                          onClick={() => {
                            if (isLoggedIn) {
                              navigate("/" + pageLanguage + "/Account");
                            } else {
                              dispatch({
                                type: ShowLoginModal,
                              });
                            }
                          }}
                        >
                          <Person />
                        </li>
                      )}
                    {currentPage.level1 === "Curtain" &&
                      currentPage.level3 !== undefined &&
                      isLoggedIn && (
                        <Link
                          className="login-open"
                          to={
                            isLoggedIn
                              ? "/" + pageLanguage + "/Account"
                              : "/" + pageLanguage + "/User/NewUser"
                          }
                        >
                          <Person />
                        </Link>
                      )}
                    {!(currentPage.level1 === "Curtain" && currentPage.level3 !== undefined) && (
                      <Link
                        className="login-open"
                        to={
                          isLoggedIn
                            ? "/" + pageLanguage + "/Account"
                            : "/" + pageLanguage + "/User/NewUser"
                        }
                      >
                        <Person />
                      </Link>
                    )}
                    <li className="favorite">
                      <Link to={"/" + pageLanguage + "/Favorites"}>
                        <Favorite />
                      </Link>
                    </li>
                    {(cartCount > 0 || draperyCount + productCount + swatchesCount > 0) && (
                      <li className="checkout">
                        <Link to={"/" + pageLanguage + "/Basket"}>
                          <div className="basket_icon_container">
                            <Basket />
                            <div className="count">
                              {pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(
                                    `${
                                      cartCount > 0
                                        ? cartCount
                                        : draperyCount + productCount + swatchesCount
                                    }`
                                  )
                                : cartCount > 0
                                ? cartCount
                                : draperyCount + productCount + swatchesCount}
                            </div>
                          </div>
                        </Link>
                      </li>
                    )}
                    {cartCount === 0 && draperyCount + productCount + swatchesCount === 0 && (
                      <li className="checkout">
                        <div>
                          <PopoverStickOnClick
                            btnClassNames="Header_Basket_icon"
                            classNames={
                              isLoggedIn
                                ? "Header_Basket_icon_popover Header_Basket_icon_popover2"
                                : "Header_Basket_icon_popover"
                            }
                            placement="bottom"
                            isHover={false}
                            onMouseEnter={() => {}}
                            children={
                              <div className="basket_icon_container">
                                <Basket />
                                <div className="count">
                                  {cartCount > 0
                                    ? cartCount
                                    : draperyCount + productCount + swatchesCount}
                                </div>
                              </div>
                            }
                            component={
                              <div className="card_menu_title">
                                <div className="basket_empty_header_1">
                                  {t("basket_empty_header_1")}
                                </div>
                                {!isLoggedIn && (
                                  <div className="basket_empty_header_2">
                                    {t("basket_empty_header_2")}
                                    <span
                                      className="text_underline header_basket_sign_in"
                                      onClick={() => navigate("/" + pageLanguage + "/User")}
                                    >
                                      {t("basket_empty_header_3")}
                                    </span>
                                    {t("basket_empty_header_4")}
                                  </div>
                                )}
                              </div>
                            }
                          />
                        </div>
                      </li>
                    )}
                  </ul>
                  <ul
                    className={`Lang_change_container ${
                      pageLanguage === "fa" ? "float_left" : "float_right"
                    }`}
                  >
                    <li className="Lang_change">
                      <Link
                        to={{
                          pathname: langLocation.locationEN,
                          search: `${location.search.replace("?", "")}`,
                        }}
                        onClick={() => i18n.changeLanguage("en")}
                        style={
                          pageLanguage === "en" ? { pointerEvents: "none", color: "#383838" } : null
                        }
                      >
                        ENGLISH
                      </Link>
                    </li>
                    <li className="lang_separator">&nbsp;|&nbsp;</li>
                    <li className="Lang_change">
                      <Link
                        to={{
                          pathname: langLocation.locationFA,
                          search: `${location.search.replace("?", "")}`,
                        }}
                        onClick={() => i18n.changeLanguage("fa")}
                        style={
                          pageLanguage === "fa" ? { pointerEvents: "none", color: "#383838" } : null
                        }
                      >
                        فارسی
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="bottom_header">
              <div className="col-lg-12">
                <div className={`menu`}>
                  <ul>
                    {!isDoopsalta2Domain ? menuRender : menuRender2}
                  </ul>
                  <div className="bghover"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="mobile_only">
            <div className="mobile_header">
              <div className="hamburger_menu">
                <div className="hamburger_menu_icon" onClick={() => setIsNavOpen(true)}>
                  <img
                    src={require("../Images/public/hamburger-menu.svg").default}
                    className="img-fluid"
                    alt=""
                  />
                </div>
              </div>
              <div className="logo_section">
                <div className="mobile_logo">
                  <Link to={"/" + pageLanguage}>
                    {pageLanguage === "en" ? <Logoen /> : <Logofa />}
                  </Link>
                </div>
              </div>
              <div className="icons_section">
                <div className="login_icon_container">
                  <div className="basket_icon_link" onClick={() => setShowSearch(!showSearch)}>
                    <img
                      src={require("../Images/public/main_search_icon.svg").default}
                      className="img-fluid search_icon"
                      alt=""
                    />
                  </div>
                </div>
                <div className="basket_icon_container">
                  <Link className="basket_icon_link" to={"/" + pageLanguage + "/Basket"}>
                    <Basket />
                    <div className="count">
                      {pageLanguage === "fa"
                        ? NumberToPersianWord.convertEnToPe(
                            `${
                              cartCount > 0
                                ? cartCount
                                : draperyCount + productCount + swatchesCount
                            }`
                          )
                        : cartCount > 0
                        ? cartCount
                        : draperyCount + productCount + swatchesCount}
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            <div
              className={
                showSearch
                  ? "header_search_container search-box"
                  : "header_search_container search-box hidden"
              }
            >
              <input
                type="text"
                name="serach_input"
                className={`input-search ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
                placeholder={t("Search_placeholder")}
                autoComplete="new-search"
              />
            </div>
          </div>
          <nav
            className={isNavOpen ? "mobile_nav_container nav_open" : "mobile_nav_container"}
            ref={mobNav}
          >
            <div className="nav_header">
              <div className="nav_header_top">
                <div className="logo_section">
                  <div className="mobile_logo" onClick={() => setIsNavOpen(false)}>
                    {pageLanguage === "en" ? <Logoen /> : <Logofa />}
                  </div>
                </div>
              </div>
              <div className="nav_header_bottom">
                {currentPage.level1 === "Curtain" &&
                  currentPage.level3 !== undefined &&
                  !isLoggedIn && (
                    <div
                      className="menu_icon login-open"
                      onClick={() => {
                        if (isLoggedIn) {
                          navigate("/" + pageLanguage + "/Account");
                        } else {
                          dispatch({
                            type: ShowLoginModal,
                          });
                        }
                        setIsNavOpen(false);
                        setIsSubNavOpen({});
                      }}
                    >
                      <Person />
                      <span>{isLoggedIn ? t("Account") : t("Log In / Sign Up")}</span>
                    </div>
                  )}
                {currentPage.level1 === "Curtain" &&
                  currentPage.level3 !== undefined &&
                  isLoggedIn && (
                    <Link
                      className="menu_icon login-open"
                      to={
                        isLoggedIn
                          ? "/" + pageLanguage + "/Account"
                          : "/" + pageLanguage + "/User/NewUser"
                      }
                    >
                      <Person />
                      <span>{isLoggedIn ? t("Account") : t("Log In / Sign Up")}</span>
                    </Link>
                  )}
                {!(currentPage.level1 === "Curtain" && currentPage.level3 !== undefined) && (
                  <Link
                    className="menu_icon login-open"
                    to={
                      isLoggedIn
                        ? "/" + pageLanguage + "/Account"
                        : "/" + pageLanguage + "/User/NewUser"
                    }
                  >
                    <Person />
                    <span>{isLoggedIn ? t("Account") : t("Log In / Sign Up")}</span>
                  </Link>
                )}
                <div className="close_menu_icon" onClick={() => setIsNavOpen(false)}>
                  <img
                    src={require("../Images/public/close-button.png")}
                    className="img-fluid"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div className="nav_body">
              <ul className="nav_body_items">
                {!isDoopsalta2Domain ? mobMenuRender : mobMenuRender2}
              </ul>
            </div>
            <div className="nav_footer">
              <ul className={`Lang_change_container`}>
                <li className="Lang_change">
                  <Link
                    to={{
                      pathname: langLocation.locationEN,
                      search: `${location.search.replace("?", "")}`,
                    }}
                    onClick={() => i18n.changeLanguage("en")}
                    style={
                      pageLanguage === "en" ? { pointerEvents: "none", color: "#383838" } : null
                    }
                  >
                    ENGLISH
                  </Link>
                </li>
                <li className="lang_separator">&nbsp;|&nbsp;</li>
                <li className="Lang_change">
                  <Link
                    to={{
                      pathname: langLocation.locationFA,
                      search: `${location.search.replace("?", "")}`,
                    }}
                    onClick={() => i18n.changeLanguage("fa")}
                    style={
                      pageLanguage === "fa" ? { pointerEvents: "none", color: "#383838" } : null
                    }
                  >
                    فارسی
                  </Link>
                </li>
              </ul>
            </div>
          </nav>
        </div>

        {/* Modals */}

        <Modal
          backdrop="static"
          keyboard={false}
          dialogClassName={`login_modal fullSizeModal login_page_container ${
            pageLanguage === "fa" ? "font_farsi" : "font_en"
          }`}
          show={showLogin}
          onHide={() =>
            dispatch({
              type: HideLoginModal,
            })
          }
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div className="logo_container">
              <div className="Logo">
                <Link to="/">{pageLanguage === "en" ? <Logoen /> : <Logofa />}</Link>
              </div>
            </div>
            {!resetPage && errorText !== "" && (
              <div className="login_page_error_text">{errorText}</div>
            )}
            {!resetPage && successText !== "" && (
              <div className="login_page_success_text">{successText}</div>
            )}
            {!resetPage && (
              <div className="login_register_container">
                <div className="login_container">
                  <div className="login_inside_container">
                    <h1 className="login_title">{t("SIGN IN TO YOUR ACCOUNT")}</h1>
                    <input
                      type="text"
                      placeholder={t("Email*")}
                      className="form-control"
                      name="Email"
                      value={loginInfo.email}
                      onChange={(e) => {
                        let temp = JSON.parse(JSON.stringify(loginInfo));
                        temp.email = e.target.value;
                        setLoginInfo(temp);
                      }}
                    />
                    <input
                      type="password"
                      placeholder={t("Password*")}
                      className="form-control form-control-password"
                      name="Password"
                      value={loginInfo.password}
                      autoComplete="new-password"
                      onChange={(e) => {
                        let temp = JSON.parse(JSON.stringify(loginInfo));
                        temp.password = e.target.value;
                        setLoginInfo(temp);
                      }}
                    />
                    <div className="remember_forgot_container">
                      <div className="remember_container"></div>
                      <div className="forgot text_underline" onClick={() => setResetPage(true)}>
                        {t("Forgot your password?")}
                      </div>
                    </div>
                    <div className="login_btn_container">
                      <button
                        className="login_btn btn btn-new-dark"
                        onClick={() => loginUser()}
                        disabled={btn_disabled}
                        ref={signIn}
                      >
                        {t("SIGN IN")}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="register_container">
                  <div className="register_inside_container">
                    <h1 className="login_title">{t("CREATE AN ACCOUNT")}</h1>
                    <p className="login_text">{t("register_list_title")}</p>
                    <ul className="register_list">
                      <li className="register_list_item">{t("register_list_item0")}</li>
                      <li className="register_list_item">{t("register_list_item1")}</li>
                      <li className="register_list_item">{t("register_list_item2")}</li>
                      <li className="register_list_item">{t("register_list_item3")}</li>
                    </ul>
                    {!showRegister && (
                      <button className="register_btn btn" onClick={() => setShowRegister(true)}>
                        {t("LET'S GO")}
                      </button>
                    )}
                    {showRegister && (
                      <div className="register_section_container">
                        <div className="register_section_item">
                          <input
                            type="text"
                            placeholder={t("First Name*")}
                            className={
                              "form-control " + (firstNotExist ? "password_not_valid" : "")
                            }
                            name="name"
                            value={registerInfo.firstName}
                            onChange={(e) => {
                              let temp = JSON.parse(JSON.stringify(registerInfo));
                              temp.firstName = e.target.value;
                              setRegisterInfo(temp);
                              if (e.target.value.length > 0) {
                                setFirstNotExist(false);
                              }
                            }}
                          />
                          {firstNotExist && (
                            <div className="input_not_valid">{t("First Name Required.")}</div>
                          )}
                        </div>
                        <div className="register_section_item">
                          <input
                            type="text"
                            placeholder={t("Last Name*")}
                            className={"form-control " + (lastNotExist ? "password_not_valid" : "")}
                            name="lastName"
                            value={registerInfo.lastName}
                            onChange={(e) => {
                              let temp = JSON.parse(JSON.stringify(registerInfo));
                              temp.lastName = e.target.value;
                              setRegisterInfo(temp);
                              if (e.target.value.length > 0) {
                                setLastNotExist(false);
                              }
                            }}
                          />
                          {lastNotExist && (
                            <div className="input_not_valid">{t("Last Name Required.")}</div>
                          )}
                        </div>
                        <div className="register_section_item">
                          <input
                            type="email"
                            placeholder={t("Email*")}
                            className={
                              "form-control " +
                              (emailNotValid || emailNotExist ? "password_not_valid" : "")
                            }
                            name="Email"
                            value={registerInfo.email}
                            onChange={(e) => {
                              let temp = JSON.parse(JSON.stringify(registerInfo));
                              temp.email = e.target.value;
                              setRegisterInfo(temp);
                              if (e.target.value.length > 0) {
                                setEmailNotExist(false);
                                if (validateEmail(e.target.value)) {
                                  setEmailNotValid(false);
                                }
                              }
                            }}
                          />
                          {emailNotValid && (
                            <div className="input_not_valid">
                              {emailError[pageLanguage][emailErrorState]["error"]}
                            </div>
                          )}
                          {emailNotExist && (
                            <div className="input_not_valid">{t("Email Required.")}</div>
                          )}
                        </div>
                        <div className="register_section_item">
                          <input
                            type="text"
                            placeholder={t("Mobile Number (Optional)")}
                            className={
                              "form-control " + (mobileNotExist ? "password_not_valid" : "")
                            }
                            name="mobile"
                            value={registerInfo.phone}
                            onChange={(e) => {
                              let temp = JSON.parse(JSON.stringify(registerInfo));
                              temp.phone = e.target.value.replace(/\D/g, "").replace(/[^0-9]/g, "");
                              setRegisterInfo(temp);
                              validateNumber(e.target.value?.toString());
                            }}
                          />
                          {mobileNotExist && (
                            <div className="input_not_valid">
                              {mobileError[pageLanguage][mobileErrorState]["error"]}
                            </div>
                          )}
                        </div>
                        <div className="register_section_item">
                          <input
                            type="password"
                            placeholder={t("Password*")}
                            className={
                              "form-control form-control-password " +
                              (passwordNotValid ? "password_not_valid" : "")
                            }
                            name="Register_Password"
                            value={registerInfo.password}
                            autoComplete="new-password"
                            onChange={(e) => {
                              let temp = JSON.parse(JSON.stringify(registerInfo));
                              temp.password = e.target.value.replace(/\s/g, "");
                              // temp.password = temp.password.replace(/[^0-9A-Za-z\s]/g, '');
                              setRegisterInfo(temp);
                              if (temp.password === temp.passwordConfirm) {
                                setPasswordMatch(true);
                                setPasswordMatchNotValid(false);
                              } else setPasswordMatch(false);
                              checkPasswordStrength(temp.password);
                            }}
                            onClick={() => setShowPasswordValidation(true)}
                          />
                          {showPasswordValidation && (
                            <div className="input_not_valid_password ">
                              <h2 className="input_not_valid_password_title">
                                {t("Your password must contain:")}
                              </h2>
                              <ul className="input_not_valid_password_list">
                                <li
                                  className={
                                    "input_not_valid_password_item " +
                                    (passwordValidation.count
                                      ? "input_not_valid_password_item_check"
                                      : "")
                                  }
                                >
                                  <span>
                                    {passwordValidation.count && (
                                      <img
                                        className="checkmark1 img-fluid"
                                        src={require("../Images/public/checkmark1.png")}
                                        alt=""
                                      />
                                    )}
                                    {t("password_required_text1")}
                                  </span>
                                </li>
                                <li
                                  className={
                                    "input_not_valid_password_item " +
                                    (passwordValidation.lowercase
                                      ? "input_not_valid_password_item_check"
                                      : "")
                                  }
                                >
                                  <span>
                                    {passwordValidation.lowercase && (
                                      <img
                                        className="checkmark1 img-fluid"
                                        src={require("../Images/public/checkmark1.png")}
                                        alt=""
                                      />
                                    )}
                                    {t("password_required_text2")}
                                  </span>
                                </li>
                                <li
                                  className={
                                    "input_not_valid_password_item " +
                                    (passwordValidation.uppercase
                                      ? "input_not_valid_password_item_check"
                                      : "")
                                  }
                                >
                                  <span>
                                    {passwordValidation.uppercase && (
                                      <img
                                        className="checkmark1 img-fluid"
                                        src={require("../Images/public/checkmark1.png")}
                                        alt=""
                                      />
                                    )}
                                    {t("password_required_text3")}
                                  </span>
                                </li>
                                <li
                                  className={
                                    "input_not_valid_password_item " +
                                    (passwordValidation.numbers
                                      ? "input_not_valid_password_item_check"
                                      : "")
                                  }
                                >
                                  <span>
                                    {passwordValidation.numbers && (
                                      <img
                                        className="checkmark1 img-fluid"
                                        src={require("../Images/public/checkmark1.png")}
                                        alt=""
                                      />
                                    )}
                                    {t("password_required_text4")}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          )}
                        </div>
                        <div className="register_section_item">
                          <input
                            type="password"
                            placeholder={t("Confirm Password*")}
                            className={
                              "form-control form-control-password " +
                              (passwordMatchNotValid ? "password_not_valid" : "")
                            }
                            name="Register_PasswordConfirm"
                            value={registerInfo.passwordConfirm}
                            autoComplete="new-password"
                            onChange={(e) => {
                              let temp = JSON.parse(JSON.stringify(registerInfo));
                              temp.passwordConfirm = e.target.value;
                              setRegisterInfo(temp);
                              if (temp.password === temp.passwordConfirm) {
                                setPasswordMatch(true);
                                setPasswordMatchNotValid(false);
                              } else setPasswordMatch(false);
                            }}
                          />
                          {passwordMatchNotValid && (
                            <div className="input_not_valid">
                              {t("Password confirmation is required.")}
                            </div>
                          )}
                        </div>
                        <div className="news_signup">
                          <div className="checkbox_style">
                            <input
                              type="checkbox"
                              checked={registerInfo.news}
                              onChange={(e) => {
                                let temp = JSON.parse(JSON.stringify(registerInfo));
                                temp.news = e.target.checked;
                                setRegisterInfo(temp);
                              }}
                              id="registerInfonews"
                            />
                            <label htmlFor="registerInfonews" className="checkbox_label">
                              <img
                                className="checkbox_label_img checkmark1 img-fluid"
                                src={require("../Images/public/checkmark1_checkbox.png")}
                                alt=""
                              />
                            </label>
                            <span className="checkbox_text">{t("signup to email")}</span>
                          </div>
                        </div>
                        <div className="login_btn_container">
                          <button
                            className="login_btn btn btn-new-dark"
                            onClick={() => registerUser()}
                            disabled={btn_disabled}
                          >
                            {t("CREATE AN ACCOUNT")}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

            {resetPage && (
              <div className="Forgot_page_container login_register_container">
                <div className="login_container">
                  <div className="login_inside_container">
                    <h1 className="login_title">{t("Forgot Password")}</h1>
                    <h2 className="forget_text forget_text_small">{t("forgot_page_text")}</h2>
                    <input
                      type="text"
                      placeholder={t("Email*")}
                      className="form-control"
                      name="Email"
                      value={forgotEmail}
                      onChange={(e) => {
                        setForgotEmail(e.target.value);
                      }}
                    />

                    <div className="login_btn_container">
                      <button
                        className="login_btn btn btn-new-dark"
                        onClick={() => {
                          sendResetPasswordRequest();
                          setResetPage(false);
                        }}
                      >
                        {t("SUBMIT")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Modal.Body>
        </Modal>

        <Modal
          backdrop="static"
          keyboard={false}
          className={`cart_modal_container cart_agree_container add_to_project_modal ${
            pageLanguage === "fa" ? "font_farsi" : "font_en"
          }`}
          dialogClassName={`cart_modal ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
          show={showLogin2}
          onHide={() =>
            dispatch({
              type: HideLogin2Modal,
            })
          }
          id="add_to_project_modal"
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <ModalLogin />
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}

export default Header;
